// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1EsKD","left":"styles_left__qFcgv","select":"styles_select__2IMzf"};